const cacheKeyFor = (username: string) =>
  `designTokens:${username.toLowerCase()}`;
const legacyDesignKeyFor = (username: string) =>
  `design:${username.toLowerCase()}`;

/** Synchronous localStorage read for first-paint theme only — not a source of truth. */
export function readCachedUserDesignTokens(
  username: string | null | undefined,
): Record<string, any> | undefined {
  if (!username) return undefined;
  try {
    const raw = localStorage.getItem(cacheKeyFor(username));
    return raw ? JSON.parse(raw) : undefined;
  } catch {
    return undefined;
  }
}

export function writeCachedUserDesignTokens(
  username: string,
  tokens: Record<string, any>,
): void {
  try {
    localStorage.setItem(cacheKeyFor(username), JSON.stringify(tokens));
  } catch {}
  // Legacy snake_case cache that DesignContext may read on other routes.
  try {
    const legacy = {
      ...tokens,
      font_family: tokens?.fontFamily ?? tokens?.font_family ?? "",
      primary_font_family:
        tokens?.primaryFontFamily ?? tokens?.primary_font_family ?? "",
      secondary_font_family:
        tokens?.secondaryFontFamily ?? tokens?.secondary_font_family ?? "",
      background_style: tokens?.primaryColor ?? tokens?.background_style ?? "",
      button_background:
        tokens?.secondaryColor ?? tokens?.button_background ?? "",
      button_text: tokens?.tertiaryColor ?? tokens?.button_text ?? "",
      button_border: tokens?.button_border ?? "",
      text_color: tokens?.text_color ?? "",
      social_icon_color: tokens?.social_icon_color ?? "",
      template_name: tokens?.templateName ?? tokens?.template_name ?? "",
      card_style: tokens?.card_style ?? tokens?.card_style,
    };
    localStorage.setItem(legacyDesignKeyFor(username), JSON.stringify(legacy));
  } catch {}
}
